/**
 * Unified Airbank layout surfaces — use for header, sidebar, and main canvas
 * so dark mode reads as one continuous charcoal plane (not mixed greys/blues).
 */
export const AIRBANK_DARK_CANVAS = "#0a0a0b";
export const AIRBANK_DARK_ELEVATED = "#111113";
/** Nested cards / tiles on top of elevated panels */
export const AIRBANK_DARK_CARD = "#141416";
export const AIRBANK_DARK_BORDER_SUBTLE = "rgba(249, 168, 37, 0.14)";
export const AIRBANK_LIGHT_CANVAS = "#f8fafc";
